'use client'


// import { CommonListContext } from "@/app/analysis/_config";
import {CommonListContext} from "@/util/board_config"
import { NavContext } from "@/context/navContext";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslations } from "next-intl";



interface RankInfo {
    create_dt: string,
    id: number,
    rank: number,
    site: string,
    verifiedsite_logo:string
}

interface CompanyItem {
  id: number
  name: string
  rank_info: RankInfo[]
}

interface VerifiedRankListProps {
  list: CompanyItem[]
  setActive?: (active: boolean) => void,
  smallType?:boolean
}


export default function VerifiedRankListComponent({
  list,
  setActive,
  smallType=true,
}: VerifiedRankListProps) {
    const { movePage } = useContext(NavContext)

    const a = useTranslations("Sentence")


    return (
        <>
        {list.length > 0 ?
            (
            <div className={`mypage-verified-container ${smallType ? "": "includeLogo"}`}>
                {
                list.map((li, index)=> (
                    <div className="company-item" key={li.id}>
                        <header>{li.name}</header>
                        <ul>
                            { li.rank_info && 
                                li.rank_info.map((rk, index)=> (
                                    <li key={rk.id}className={`${smallType ? "": "includeLogo"}`} 
                                        onClick={()=>{
                                            if(setActive) setActive(false)
                                            movePage(`/partnership/?id=${rk.id}`)
                                     }}>
                                        <div>{rk.rank}</div>
                                        {!smallType && 
                                            <div>
                                                <img src={`${rk.verifiedsite_logo||"/image/etc/verifiedsite_logo.png"}`}
                                                    onError={(e) => {
                                                            e.currentTarget.onerror = null;
                                                            e.currentTarget.src = "/image/etc/verifiedsite_logo.png";
                                                        }}  />
                                            </div>
                                        }
                                        <div>{rk.site}</div>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                ))
                }
            
            </div>
            )
        :
            (
                <div className="loadingWrapper">
                    <ul className="listV2 verified-list-container-new empty">
                        <li className="empty">{a('InvalidPartnersRankList')}</li>
                    </ul>
                </div>
            )

        }
        </>
    )
}